import { useTranslation } from 'react-i18next';
import styles from './checkoutLayout.module.scss';
import { ArrowLeftIcon } from './icons';

export function ContinueShopping({
  href,
  onClick,
}: {
  href?: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.continueRow}>
      {href ? (
        <a className={styles.continueBtn} href={href}>
          <ArrowLeftIcon className={styles.continueIcon} />
          {t('Continue shopping')}
        </a>
      ) : (
        <button type="button" className={styles.continueBtn} onClick={onClick}>
          <ArrowLeftIcon className={styles.continueIcon} />
          {t('Continue shopping')}
        </button>
      )}
    </div>
  );
}
